/**
 * Nhãn cho từng ca cabin trong modal chi tiết.
 *
 * Người duyệt mở modal để trả lời một câu: **học viên này đã thật sự học chưa?**
 * Nên bốn trạng thái không được lẫn vào nhau — nhất là VẮNG với ĐÃ HỌC. Một ca
 * đã qua mà bị đánh vắng thì không tính là đã học, và đó chính là chỗ cảnh báo
 * dễ sai: 7,6% học viên học hai ca là thật, trong đó có người vắng ca cũ nên
 * đặt ca mới — họ chưa học buổi nào.
 *
 * Hàm thuần, không JSX, để test được.
 */

export const NHAN_CA = {
  da_huy: { nhan: 'Đã hủy', bg: 'secondary' },
  vang: { nhan: 'Vắng', bg: 'danger' },
  sap_toi: { nhan: 'Sắp tới', bg: 'primary' },
  da_hoc: { nhan: 'Đã học', bg: 'success' },
};

/** Ca coi là không còn hiệu lực — cùng tập với `KHONG_HIEU_LUC` ở backend. */
const DA_HUY = ['cancelled', 'rejected'];

/**
 * @param {{status?: string, vang?: boolean, sapToi?: boolean}|null|undefined} ca
 * @returns {{key: string, nhan: string, bg: string}}
 */
export function nhanCa(ca) {
  const c = ca || {};
  // Thứ tự ưu tiên có chủ ý:
  //   hủy   > vắng  : hủy rồi thì cờ vắng vô nghĩa
  //   vắng  > đã học: ca đã qua mà bị đánh vắng là VẮNG
  //   vắng  > sắp tới: giáo viên có thể đánh vắng trước giờ ca
  let key = 'da_hoc';
  if (DA_HUY.includes(c.status)) key = 'da_huy';
  else if (c.vang === true) key = 'vang';
  else if (c.sapToi === true) key = 'sap_toi';
  return { key, ...NHAN_CA[key] };
}
